<ul class="list-group">
  @for (user of students; track user) {
    <li class="list-group-item user-item text-left">
      <div class="d-flex justify-content-between align-items-center">
        <img *ngIf="!user?.profilePicture" class="img-circle img-user img-thumbnail w-150"
          src="../../../assets/images/user/default_user.png">
        <img *ngIf="user?.profilePicture" class="img-circle img-user img-thumbnail w-150" src="{{user?.profilePicture}}">
        <h3>
          <a href="/profile/{{user.userId}}">{{user.firstName}} {{user.lastName}}</a><br>
        </h3>
        <a href="/profile/{{user.userId}}">View Profile</a>
      </div>
    </li>
  }

</ul>
